require('./bootstrap');
window.Chart = require('chart.js/auto');

document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('[data-sidebar-toggle]');
    const backdrop = document.querySelector('[data-sidebar-backdrop]');
    const setSidebar = (open) => document.body.classList.toggle('admin-sidebar-open', open);

    toggle?.addEventListener('click', () => setSidebar(!document.body.classList.contains('admin-sidebar-open')));
    backdrop?.addEventListener('click', () => setSidebar(false));

    document.querySelectorAll('[data-password-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
            const input = document.getElementById(button.dataset.passwordToggle);
            if (!input) return;
            input.type = input.type === 'password' ? 'text' : 'password';
            button.setAttribute('aria-pressed', input.type === 'text' ? 'true' : 'false');
        });
    });
});
